export default "__VITE_ASSET__yaz3ft2s__"